import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { Lottie } from 'Components/UI';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const AnswersContainer = styled(FlexContainer)`
  min-width: 448px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    min-width: 100%;
  }
`;
export const QuizContainer = styled(FlexContainer)`
  position: relative;
  width: 100%;
  max-width: 480px;
  padding: ${({ theme }) => theme.reference.dimension_16};
  height: 90%;
`;

export const KiteLottie = styled(Lottie)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
`;

export const ContentContainer = styled(FlexContainer)`
  position: relative;
  z-index: ${({ theme: { system } }) => parseInt(system.zIndex.fds_sys_zindex_default, 10) + 1};
  max-width: 480px;
`;

export const ButtonContainer = styled(FlexContainer)`
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_primary};
`;

export const QuizContent = styled(FlexContainer)`
  height: auto;
`;
